import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Container } from 'react-bootstrap';
import HomeContext from '../../../routes/context/homeContext';
import { api, homepageUploadDir } from '../../../config';
import { getDynamicTitleByName, getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import SignupGridSkeleton from '../../Skeleton/Home/SignupGridSkeleton/SignupGridSkeleton';
import s from './SignupGrid.css';

const SignupGrid = ({ currentLocale, dynamicHomePageSettings, skeletonLoading, categoryList }) => {
  const homepage = useContext(HomeContext);

  const allAppSectionData = getDynamicTitleByName({
    dynamicHomePageSettings,
    name: 'signupGridTitle1',
  });

  let appSectionData = getDynamicTitleByLocale({
    dynamicHomePageSettings: allAppSectionData,
    locale: currentLocale,
  });

  appSectionData = appSectionData?.length > 0 ? appSectionData[0] : allAppSectionData[0];

  if (skeletonLoading) {
    return (
      <SignupGridSkeleton />
    )
  }
  return (
    <div className={cx(categoryList?.filter(item => item?.isActive).length === 0 && s.noTopCategoryBottomSpace)}>
      <Container>
        <div className={cx(s.providerAppBgWrapper)} style={{
          backgroundImage: `url(${api.apiEndpoint + homepageUploadDir + homepage.signupGridImage4})`
        }} >
          <div className={s.providerAppRowGrid}>
            <div >
              <h2 className={s.providerAppHeading}>{appSectionData?.value}</h2>
              <p className={s.providerAppDesc}>{appSectionData?.description}</p>
              <div className={s.providerAppBtnGroup}>
                <a href={homepage.signupGridLink1} target="_blank" rel="noopener noreferrer" className={s.providerAppBtnLink}>
                  <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage1} alt="Download on App Store" />
                </a>
                <a href={homepage.signupGridLink2} target="_blank" rel="noopener noreferrer" className={s.providerAppBtnLink}>
                  <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage2} alt="Get it on Google Play" />
                </a>
              </div>
            </div>

            <div className={cx(s.providerAppImageWrapper, 'providerAppImageWrapperRTL')}>
              <img src={api.apiEndpoint + homepageUploadDir + homepage.signupGridImage3} alt="App Preview" />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default withStyles(s)(SignupGrid);
